/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Img } from '../CompleteRegister/style'
import { LogoDustre } from './style'
import LogoImg from '../../../assets/login/logo.png'
import {
  Container,
  InputButton,
  Label,
  LoginForm,
  MainText,
  TextInput,
  ErrorContainer,
} from './style'
import { Condition, ConditionIcon } from './style'
import { Password } from 'primereact/password'
import axios from '../../../config/axios'
import jwtDecode from 'jwt-decode'

function InternalAccess() {
  const [name, setName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const { token } = useParams()
  const [valid, setValid] = useState<boolean>(false)

  useEffect(() => {
    if (token == undefined) {
      setValid(false)
    } else {
      tryToken(token)
    }
  }, [token])

  const tryToken = async (token: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/new-admin/${token}`,
      )
      setValid(response.data)
      // Preferir dados retornados pelo backend
      if (response.data && response.data.email) {
        setEmail(response.data.email)
      }
    } catch (error) {
      console.log(error)
      return false
    }
  }

  function handleRegister(): void {
    if (name && phone && password) {
      axios
        .post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user`, {
          name,
          email,
          phone,
          password,
          company: 'Dustre',
          cnpj: '03954227000164',
          picture: '',
          adminUser: true,
          approved: 'approved',
          permissions: ['order status', 'stock'],
        })
        .then((res) => {
          if (res) {
            window.location.href = '/'
          }
        })

        .catch((err) => {
          console.log(err)
        })
    }
  }

  const SpecialCharacters = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/

  let SizeCondition = false
  const UpperCondition = /[A-Z]/.test(password)
  const SpecialCondition = SpecialCharacters.test(password)

  if (password.length >= 4 && password.length <= 24) {
    SizeCondition = true
  }

  return (
    <>
      <Img></Img>
      {valid ? (
        <Container>
          <LogoDustre src={LogoImg} alt='Logo da Dustre' />
          <MainText>Finalize seu cadastro</MainText>
          <LoginForm>
            <Label htmlFor='name'>Nome</Label>
            <TextInput
              type='string'
              name='name'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <Label htmlFor='phone'>Telefone</Label>
            <TextInput
              type='text'
              name='phone'
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <Label htmlFor='password'>Senha</Label>
            <Password
              feedback={false}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              toggleMask
            />

            <Condition className={SizeCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={SizeCondition ? 'ok' : 'notok'} />
              Entre 4 e 24 caracteres
            </Condition>
            <Condition className={UpperCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={UpperCondition ? 'ok' : 'notok'} />
              No mínimo uma letra maiúscula
            </Condition>
            <Condition className={SpecialCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={SpecialCondition ? 'ok' : 'notok'} />
              No mínimo um número ou caractere especial
            </Condition>
            <InputButton
              onClick={handleRegister}
              type='button'
              value='Cadastrar'
              disabled={!(SizeCondition && UpperCondition && SpecialCondition)}
            />
          </LoginForm>
        </Container>
      ) : (
        <ErrorContainer>
          <LogoDustre src={LogoImg} alt='Logo da Dustre' />
          <MainText>Link expirado ou inválido.</MainText>
        </ErrorContainer>
      )}
    </>
  )
}

export default InternalAccess
